import { render, staticRenderFns } from "./FeatureArticle.vue?vue&type=template&id=8747ee08&scoped=true&"
import script from "./FeatureArticle.vue?vue&type=script&lang=js&"
export * from "./FeatureArticle.vue?vue&type=script&lang=js&"
import style0 from "./FeatureArticle.vue?vue&type=style&index=0&id=8747ee08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8747ee08",
  null
  
)

export default component.exports